import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { Card, Col, Row, Table, Button, Input, Space, Tooltip } from "antd";
import { cloneDeep, forEach, get, map } from "lodash";
import React, { FC, useEffect, useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import "./arSummary.scss"
import { TableLocale } from "@components/noDataFound";
const TablePreloader = () => {
  return (
    <Row className="tableWrapper">
      <Col span={24}>
        <div className="table-preloader">
          {map(Array.from(Array(5).keys()), (item: any) => {
            return (
              <div className="table-preloader__row" key={"row_" + item}>
                {map(Array.from(Array(5).keys()), (item: any) => {
                  return (
                    <div key={"col_" + item} className="table-preloader__row__column">
                      <div className="table-preloader__row__column__sub-title shimmerBG"></div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className="pagination_preload">
          <div className="pagination_text_preloader shimmerBG"></div>
        </div>
      </Col>
    </Row>
  );
};

const highlighterDiv = (text: any, searchWord: any) => {
  return (
    <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
      {/* <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[searchWord]}
              autoEscape
              textToHighlight={text ? text.toString() : ""}
            /> */}
      {typeof text === "number" ? Number(text).toFixed(2) : text}
    </Tooltip>
  );
};

const ARSummary: FC<any> = ({ setArReportAppointmentDetails }) => {
  const selectedPatientProfile = useCalenderViewStore((state) => state.selectedPatientProfile);
  const [patientDayARSummaryDetails, setPatientDayARSummaryDetails] = useState<any>([]);
  const [arSummaryLoader, setArSummaryLoader] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [arsummaryData, setArsummaryData] = useState<any>();
  const [columnSearchInfo, setColumnSearchInfo] = useState({});
  const [column, setColumn] = useState<any>();
  // let data12: any[] = [];
  // let col12: any[] = [];

  let columnWithDollorFormat = ["current_period", "over_30", "over_60", "over_90", "over_120", "over_180", "over_270", "over_360", "total_ar"];

  useEffect(() => {
    console.log("ARSummary.useEffect");
    setArSummaryLoader(true);
    dashboardService.fetchCalenderViewPatientDayARSummaryByPatientID(selectedPatientProfile).subscribe({
      next: (v) => {
        setPatientDayARSummaryDetails(v.data.data.result);
        setArSummaryLoader(false);
        setArReportAppointmentDetails(v.data.data.result);
      },

      error: (e) => {
        console.log(e);
        setArSummaryLoader(false);
      },
    });
  }, [selectedPatientProfile, setArReportAppointmentDetails]);

  useEffect(() => {
    console.log("ARSummary.useEffect1");
    const tempcoldata: any = [];
    forEach(patientDayARSummaryDetails[0], (patientProperties) => {
      let appObj = {
        title: "",
        dataIndex: "",
        key: "",
        sorter: (a: any, b: any) => {
          a[appObj.dataIndex] = a[appObj.dataIndex] ? a[appObj.dataIndex] : "";
          b[appObj.dataIndex] = b[appObj.dataIndex] ? b[appObj.dataIndex] : "";
          return a[appObj.dataIndex].localeCompare(b[appObj.dataIndex]);
        },
      };
      appObj.title = patientProperties.label;
      appObj.dataIndex = patientProperties.columnName;
      appObj.key = patientProperties.columnName;
      tempcoldata.push(appObj);
    });
    setColumn(tempcoldata);
    const tempArsummaryData: any = [];
    forEach(patientDayARSummaryDetails, (singleAppointment) => {
      if (singleAppointment) {
        let appObj: any = {};
        forEach(singleAppointment, (patientProperties) => {
          appObj[patientProperties.columnName] = patientProperties.value;
        });
        tempArsummaryData.push(appObj);
      }
    });
    setArsummaryData(tempArsummaryData);
    setData(tempArsummaryData);
  }, [patientDayARSummaryDetails]);

  // forEach(col12, (elm)=>console.log(elm))
  // console.log("column done")
  // forEach(data12, (elm)=>console.log(elm))

  const applyColumnSearch = (columnName: any, text: any) => {
    text = text ? text : get(columnSearchInfo, [columnName], "");
    if (text !== "") {
      let tempArSummaryData = data.filter((data: any) => {
        if (data[columnName]) {
          return data[columnName].toString().toLowerCase().includes(text.toLowerCase());
        } else {
          return false;
        }
      });
      setArsummaryData(tempArSummaryData);
    } else {
      setArsummaryData(data);
    }
  };

  const inputref = useRef<any>(null);
  const _xyz: Array<{}> = map(cloneDeep(column), (dataInfo: any) => {
    return {
      ...dataInfo,

      filterDropdown: ({ confirm }: any) => (
        <div style={{ padding: "10px" }}>
          <Input
            style={{ marginBottom: 8, display: "block" }}
            value={get(columnSearchInfo, dataInfo.dataIndex, "")}
            ref={inputref}
            onChange={(e) => {
              e.preventDefault();
              setColumnSearchInfo({
                ...columnSearchInfo,
                [dataInfo.dataIndex]: e.target.value,
              });
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                e.preventDefault();
                setColumnSearchInfo({
                  [dataInfo.dataIndex]: get(columnSearchInfo, dataInfo.dataIndex, ""),
                });
                applyColumnSearch(dataInfo.dataIndex, "");
                confirm({ closeDropdown: true });
              }
            }}
          />
          <Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
              onClick={(e) => {
                e.stopPropagation();
                setColumnSearchInfo({
                  [dataInfo.dataIndex]: get(columnSearchInfo, dataInfo.dataIndex, ""),
                });
                applyColumnSearch(dataInfo.dataIndex, "");
                confirm({ closeDropdown: true });
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                setColumnSearchInfo({ [dataInfo.dataIndex]: "" });
                applyColumnSearch("", "");
                confirm({ closeDropdown: true });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon:
        dataInfo.dataIndex === "action"
          ? null
          : () => (
              <SearchOutlined
                style={{
                  color: get(columnSearchInfo, dataInfo.dataIndex, "") !== "" ? "#EF6D2A" : undefined,
                }}
              />
            ),
      render:
        dataInfo.dataIndex === "sum_of_90_over_total"
          ? (text: any, record: any) => highlighterDiv(`${text.toFixed(2)} %`, get(columnSearchInfo, dataInfo.dataIndex, ""))
          :columnWithDollorFormat.includes(dataInfo.dataIndex) ? (text: any, record: any) => highlighterDiv(`$ ${text.toFixed(2)}`, get(columnSearchInfo, dataInfo.dataIndex, ""))
          : (text: any, record: any) => highlighterDiv(text, get(columnSearchInfo, dataInfo.dataIndex, "")),
      onFilter: (value: any, record: any) => (record[dataInfo.dataIndex] ? record[dataInfo.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ""),
      onFilterDropdownOpenChange: (visible:any) => {
        if (visible) {
          setTimeout(() => inputref.current?.select(), 100);
        }
      },
    };
  });

  return arSummaryLoader ? (
    <TablePreloader />
  ) : (
    <div>
      <Card>
        <Row>
          <Col span={24}>
            <div className="arsummary-table">
              <Table
                bordered={true}
                pagination={{
                  defaultPageSize: 5,
                  showSizeChanger: true,
                  pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                }}
                // loading={loading}
                columns={_xyz}
                dataSource={arsummaryData}
                scroll={{ x: 1200 }}
                size="small"
                locale={TableLocale}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ARSummary;
